import { AppContext } from '../../context/context.esm.js';
import { useContext, useMemo, useCallback, useState, useEffect } from 'react';
import { UNIFIED_SEARCHBAR_DROPDOWN, SEARCHBAR_DEFAULTS } from '../constants.esm.js';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var GALLERY_ROUTES_MAP = {
    appGallery: SEARCHBAR_DEFAULTS.DROPDOWN[0],
    appDetails: SEARCHBAR_DEFAULTS.DROPDOWN[0],
    privateOfferDetails: SEARCHBAR_DEFAULTS.DROPDOWN[0],
    serviceGallery: SEARCHBAR_DEFAULTS.DROPDOWN[1],
    serviceDetails: SEARCHBAR_DEFAULTS.DROPDOWN[1],
    cloudsIndustryGallery: SEARCHBAR_DEFAULTS.DROPDOWN[2],
    cloudIndustryDetails: SEARCHBAR_DEFAULTS.DROPDOWN[2],
    partners: SEARCHBAR_DEFAULTS.DROPDOWN[3],
    partnersHost: SEARCHBAR_DEFAULTS.DROPDOWN[3],
    partnerDetails: SEARCHBAR_DEFAULTS.DROPDOWN[3],
    partnerDetailsContact: SEARCHBAR_DEFAULTS.DROPDOWN[3],
    partnerSuggestion: SEARCHBAR_DEFAULTS.DROPDOWN[3]
};
var UNIFIED_GALLERY_ROUTES_MAP = {
    appGallery: UNIFIED_SEARCHBAR_DROPDOWN[0],
    appDetails: UNIFIED_SEARCHBAR_DROPDOWN[0],
    privateOfferDetails: UNIFIED_SEARCHBAR_DROPDOWN[0],
    serviceGallery: UNIFIED_SEARCHBAR_DROPDOWN[1],
    serviceDetails: UNIFIED_SEARCHBAR_DROPDOWN[1],
    cloudsIndustryGallery: UNIFIED_SEARCHBAR_DROPDOWN[2],
    cloudIndustryDetails: UNIFIED_SEARCHBAR_DROPDOWN[2],
    partners: UNIFIED_SEARCHBAR_DROPDOWN[3],
    partnersHost: UNIFIED_SEARCHBAR_DROPDOWN[3],
    partnerDetails: UNIFIED_SEARCHBAR_DROPDOWN[3],
    partnerDetailsContact: UNIFIED_SEARCHBAR_DROPDOWN[3],
    partnerSuggestion: UNIFIED_SEARCHBAR_DROPDOWN[3]
};
function useGallery(options, currentView) {
    var unifiedExperience = useContext(AppContext).unifiedExperience;
    var galleryRoutesMap = useMemo(function() {
        return unifiedExperience ? UNIFIED_GALLERY_ROUTES_MAP : GALLERY_ROUTES_MAP;
    }, [
        unifiedExperience
    ]);
    var getCurrentGallery = useCallback(function() {
        var galleryKey = Object.keys(galleryRoutesMap).find(function(key) {
            return currentView === null || currentView === void 0 ? void 0 : currentView.includes(key);
        });
        var item = galleryRoutesMap["".concat(galleryKey)];
        if (!item) {
            return options[0];
        }
        return item;
    }, [
        currentView,
        options,
        galleryRoutesMap
    ]);
    var _useState = _sliced_to_array(useState(function() {
        return getCurrentGallery();
    }), 2), gallery = _useState[0], setGallery = _useState[1];
    useEffect(function() {
        var item = getCurrentGallery();
        if (item) {
            setGallery(item);
        }
    }, [
        currentView,
        getCurrentGallery
    ]);
    return [
        gallery,
        setGallery
    ];
}

export { useGallery };
